
import { ProfileContent } from "../../components/auth";

export default function Profile() {

  return (
    <>
      <ProfileContent/>
    </>
  )

}